import React from 'react';
import styled from 'styled-components';
import { Container } from '@nfs-react/components';
import PropTypes from 'prop-types';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Article = ({
  openPopup,
}) => {
  return (
    <ChangeableBackgroundSection
      id="article-wrapper-bg"
      defaultStyle={{ backgroundColor: '#fff' }}
    >
      <Wrapper>
        <ArticleContainer>
          <Advertorial>{useText('article__advertorial', true)}</Advertorial>
          <ArticleBlock>
            <Image onClick={openPopup}>
              {useImg('mercado_pic.webp', 'mercado')}
            </Image>
            <ArticleContent>
              <Title>{useText('article__title', true)}</Title>
              <Text>{useText('article__text', true)}</Text>
            </ArticleContent>
          </ArticleBlock>
        </ArticleContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.section`
`;

const Advertorial = styled.p`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  margin: 16px 0 32px;

  @media ${TABLET} {
    margin: 10px auto 56px;
  }

  @media ${MOBILE} {
    margin: 16px auto;
  }
`;

const ArticleContainer = styled(Container)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  max-width: 1170px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;

  h2, h3 {
    margin: 0;
  }

  @media ${TABLET} {
    /* max-width: 640px; */
  }

  @media ${MOBILE} {
    padding: 0 20px;
  }
`;

const ArticleBlock = styled.div`
  display: flex;

  @media ${TABLET} {
    flex-direction: column;
    align-items: center;
  }

  @media ${MOBILE} {
    flex-direction: column;
    align-items: center;
  }
`;

const ArticleContent = styled.div`
  width: 42%;
  padding-left: 15px;

  @media ${TABLET} {
    width: 100%;
    padding: 0 40px;
  }

  @media ${MOBILE} {
    width: 100%;
    padding: 0 40px;
  }
`;

const Title = styled.div`

  h3 {
    line-height: 24px;
    font-size: 16px;
    color: #333333;
    font-weight: 700;
    margin: 0;
  }

  @media ${TABLET} {
    margin: 32px auto 16px;
    text-align: center;
  }

  @media ${MOBILE} {
    margin: 16px auto;
    text-align: center;
  }
`;

const Text = styled.div`
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;

  @media ${TABLET} {
    text-align: center;
  }

  @media ${MOBILE} {
    text-align: center;
  }
`;

const Image = styled.div`
  cursor: pointer;
  width: 50%;

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }

  @media ${TABLET} {
    width: 100%;

    img {
      margin: 0 auto;
    }
  }

  @media ${MOBILE} {
    width: 100%;
    padding: 0 20px;

    img {
      margin: 0 auto;
    }
  }
`;

Article.propTypes = {
  openPopup: PropTypes.func.isRequired,
};

export default Article;
